import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=587816f0&"
import script from "./MainSlider.vue?vue&type=script&lang=ts&"
export * from "./MainSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports